interface descargarJSONI {
  endpoint: string;
  title: string;
}

const APP_API = window.configs.REACT_APP_API;
const BASE_URL = APP_API.slice(0, -1);

export const descargarJSON = async ({ endpoint, title }: descargarJSONI) => {
  const url = BASE_URL + endpoint;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error("Error en la solicitud");
  }

  const data = await response.json();

  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: "application/json" });
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `${title}.json`;
  link.click();
};
